import React, {memo} from 'react';
import {Handle, Position} from 'reactflow';

import {Box, IconButton, Stack, Typography} from "@mui/material";
import {IconPlayerPlayFilled} from "@tabler/icons-react";
import {useSetAtom} from "jotai";
import {ChatDrawerAtom} from "../pages/project/atoms";
import {getPalette, hexToRgba, NODE_RADIUS, NODE_SHADOW} from "./nodeTheme";


function StartNode({id, selected}) {
  const setChatDrawer = useSetAtom(ChatDrawerAtom);
  const palette = getPalette("start");

  const onPlay = () => {
    setChatDrawer({
      open: true,
      startNode: id
    })
  }

  return (
    <Box className={"node start-node"}
         sx={{
           display: "inline-flex",
           alignItems: "center",
           gap: 0.5,
           bgcolor: palette.accent,
           pl: 0.5, pr: 1.5, py: 0.5,
           borderRadius: `${NODE_RADIUS}px`,
           border: "1px solid",
           borderColor: palette.border,
           boxShadow: selected ? `${NODE_SHADOW}, 0 0 0 3px ${hexToRgba(palette.accent, 0.3)}` : NODE_SHADOW,
           transition: "box-shadow .18s ease",
         }}
    >
      <Stack direction={"row"} gap={0.75} alignItems={"center"} sx={{color: "#FFF"}}>
        <IconButton
          onClick={onPlay}
          size={"small"}
          sx={{
            borderRadius: "50% !important",
            color: "inherit",
            background: hexToRgba("#FFFFFF", 0.18),
            p: 0.5,
            "&:hover": {background: hexToRgba("#FFFFFF", 0.3)},
          }}
        >
          <IconPlayerPlayFilled size={12}/>
        </IconButton>
        <Typography sx={{fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase"}}>
          Start
        </Typography>
      </Stack>
      <Handle type="source" position={Position.Right} id={id}/>
    </Box>
  );
}

export default memo(StartNode);
